import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Checkbox from "@mui/material/Checkbox";
import {setUserOptIn} from "../../../../actions/userFunctions";


const LeadCapturePopupOptInCheckbox = (props) => {

  const {optIn, setUserOptIn} = props;

  const termsButtonClick = () => {
    setUserOptIn(!optIn);
  }

  return (
    <p className="look-checkbox">
      <Checkbox
        checked={optIn}
        onChange={termsButtonClick}
      />
      <span className="look-secondary">
        <FormattedMessage id="leadCapturePopup.optIn"/>
      </span>
    </p>
  )
};

const mapStateToProps = (store) => {
  const {optIn} = store.userState;
  return {
    optIn,
  };
};

const mapDispatchToProps = {
  setUserOptIn,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopupOptInCheckbox)
